/**
 * Swap Calculator Modals Store
 *
 * Manages modal state for swap calculator modals:
 * - Confirm reset modal
 *
 * Migrated from Recoil atom to Zustand for consistent state management.
 */

import { create } from "zustand";

interface SwapCalculatorModalsStore {
  // Confirm reset modal state
  confirmResetModalOpen: boolean;
  setConfirmResetModalOpen: (open: boolean) => void;
  openConfirmResetModal: () => void;
  closeConfirmResetModal: () => void;

  // Reset action
  reset: () => void;
}

export const useSwapCalculatorModalsStore = create<SwapCalculatorModalsStore>(
  (set) => ({
    // Initial state
    confirmResetModalOpen: false,

    // Actions
    setConfirmResetModalOpen: (open) => set({ confirmResetModalOpen: open }),
    openConfirmResetModal: () => set({ confirmResetModalOpen: true }),
    closeConfirmResetModal: () => set({ confirmResetModalOpen: false }),

    // Reset action
    reset: () => set({ confirmResetModalOpen: false }),
  })
);

// ============================================================================
// SELECTOR HOOKS - Optimal Zustand patterns with individual selectors
// ============================================================================

/**
 * Confirm reset modal selector
 */
export const useConfirmResetModal = () => {
  const isOpen = useSwapCalculatorModalsStore(
    (state) => state.confirmResetModalOpen
  );
  const setOpen = useSwapCalculatorModalsStore(
    (state) => state.setConfirmResetModalOpen
  );
  const open = useSwapCalculatorModalsStore(
    (state) => state.openConfirmResetModal
  );
  const close = useSwapCalculatorModalsStore(
    (state) => state.closeConfirmResetModal
  );

  return { isOpen, setOpen, open, close };
};
